import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FundData } from "../../../contexts/FundContext/FundInterface";

const initialState: FundData = {
  fundId: "",
  fundName: "",
  fundType: "Savings",
  description: "",
  source: "",
  availableBalance: "",
  amountToTranfer: "",
  allocateFunds: true,
  fundAmount: "",
  sourceId: "",
  isActive: "",
  transActionHistory: [],
  auditHistory: [],
  funds: [],
  activeFunds:[],
  checking: {
    fundId: 0,
    fundName: "",
    availableBalance: 0,
  },
  page: 0,
  rowsPerPage: 5,
  transactionPage:0,
  transactionRowsPerPage:5
};
const newFundSlice = createSlice({
  name: "newFundCreation",
  initialState,
  reducers: {
    setNewFundDetails: (state, action: PayloadAction<Partial<FundData>>) => {
      return { ...state, ...action.payload };
    },
    resetAllFundDetails: () => initialState,
  },
});

export const { setNewFundDetails, resetAllFundDetails } = newFundSlice.actions;
export default newFundSlice.reducer;
